import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from '../Actions';

const mapStatetoProps = state => {

    const { landing } = state;
    return {
        machineID:landing.machineID,
        location:landing.location,
        activeRole: landing.activeRole,
        timezone: landing.timezone
    }

};

const mapDispatchToProps = dispatch => ({
    ...bindActionCreators({
        setMachineID:Actions.setMachineID,
        setActiveRole:Actions.setActiveRole
    },
    dispatch
    )
});

export default connect(mapStatetoProps,mapDispatchToProps);